import GamepageTemplate from "../components/containers/GamepageTemplate";

const NitroStream2 = () =>{
    return(
        <GamepageTemplate 
            backgroundPng={"sabotage"}
            gameTitle={"NitroStream 2: Sabotage"}
            gameDescription={"Perform undercover operations to stop the NitroStream championship"}
            embedYouTubeId={"mBs0X8-aLPM?si=GN1w7imrxG1b9jxZ?si=28svE_F_bMDHy39-"}
            downloadPath={"https://drive.google.com/uc?id=1NN7MVtvoZzxRVqtTR_Y6Jb62qwPDIO7g"}
            gameVersion={"3.02"}
            versionDate={"2024-02"}
            endOfSupportDate={"2024-03-12"}
        />  
    );
};

export default NitroStream2;
